import { Component, OnInit, OnDestroy } from '@angular/core';
import { DispatcherService } from './dispatcher.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { Router } from '@angular/router';
import { MqttService } from '../Utils/mqtt.service';
import { Observable, Subscription } from 'rxjs';
import { Configuration } from '../app.configuration';
import * as myGlobals from '../globals';
import { ConfigService } from '../config.service';
import { LanguageService } from '../language.service';
import { mapStyle } from '../Utils/MapStyles';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

declare const jQuery: any;
declare const google: any;
declare const $: any;
declare const flatpickr: any;
declare const screenfull: any;
declare const Stripe: any;
declare const moment: any;
declare const swal: any;
declare const toastr: any;

@Component({
  selector: 'dispatcher',
  animations: [
    trigger('myAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('400ms', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('400ms', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ])
  ],
  templateUrl: './dispatcher.component.html',
  styleUrls: [
    './dispatcherhome/dispatcherhome.component.css',
    './dispatcher.component.css'
  ]
})
export class DispatcherComponent implements OnInit, OnDestroy {
  apres: any;
  fp_incr: any;
  pickuplat;
  pickuplong;
  droplat;
  droplong;
  currentYear = moment().format('YYYY');
  photo = [];
  codAmount: any;
  vechiletypes: any;
  approx = '...';
  approx_dist: any;
  vehicle_device_id: any;
  info;
  Path;
  card_window: any;
  policyLink = myGlobals.privacy_policy;
  termsLink = myGlobals.terms_conditin;
  zpath: any;
  getdata;
  isConnected: Observable<boolean>;
  own_later_date;
  own_drop_date: any;
  rec_name: any;
  rec_number: any;
  rec_mail: any;
  company_name: any;

  product_det: any;
  product_qty: any;
  product_wgt: any;
  vechicle_type: any;
  passDetailsContent: any;
  dynamic_latlong: any;
  file = [];
  data: any;
  fname_b: any;
  map: any;
  marker: any;
  style: any;
  fmail_b: any;
  pubnub: any;
  email: any;
  myphone: any;
  mymail: any;
  myname: any;
  first_name: any;
  phone: any;
  public submitted = false;
  current_time: any;
  current_time_var: any;
  zone_one_title: any;
  zone_amount: any;
  zone_two_title: any;
  journey_time: any;
  increment_num = 0;
  notify_bid: any;
  notify_sid: any = 0;
  approx_amount: any;
  booking_time: any;
  appt_type: number;
  zone_id_pick: any;
  zone_id_drop: any;
  notifications = [];
  result: any;
  change_pos: any;

  // current lat long varbles
  current_lat: any;
  current_lng: any;

  // pubnub variables
  pubnub_keys_pk: any;
  pubnub_keys_sk: any;

  // vehicle types;
  vehicle_types = [];
  vehicle_bool = true;
  // map varaibles
  mappickup_drop_bounds: any;
  pickup_marker_loc: any;
  drop_marker_loc: any;
  // livebooking variables
  vehicle_id: any;
  zone_one_id: any;
  zone_two_id: any;
  time_fare: any;
  dist_fare: any;
  dist: any;
  tme: any;

  show_add_card = false;
  goods_type_list = [];
  approx_dist_txt: any;
  category_id: any;
  category_name: any;
  show_error_bool = false;
  // new user validation
  signup_mail: any;
  signup_number: any;
  mail_bool = false;
  phone_bool = false;
  pickup_bool = true;
  pickup_loc_bool = false;
  drop_loc_bool = false;
  drop_bool = true;
  signup_otpcode: any;
  timer_i: any;
  counter_bool = false;
  drivers_vehicletype = [];
  drivers_vehicletype_markers = [];
  applied_amt;
  card_number = '';
  checking_vehs = false;
  pickup_ok = false;
  vehicles_empty = false;
  change_quantity = false;
  vehicles_interval: any;
  show_cards_hide = false;
  authorize_call: any;
  directionsDisplay: any;
  estimate_id: any;
  last_card_number: any;
  loose_qty = '0';
  pending_review = [];
  rating_b_details = [];
  driver_rating = [];
  rating_text = [];
  show_select = false;
  show_high_rating = false;
  show_low_rating = false;
  rating_num: any;
  rating_error = false;
  comment_error = false;
  show_highrate_comment = false;
  /*stripe payments */
  stripe_cardid: any;
  stripe_lastCard: any;
  stripe_cardType: any;
  currency: any;
  show_ratecard = false;
  validate_form: any;
  high_rating: any;
  capacity: any;
  length_var: any;
  fare: any;
  dis_fare: any;
  time_fare_est: any;
  x_mileage: any;
  x_min: any;
  handlers = 0;
  vehicle_type_load = false;
  metric_qty: any;
  /* PAYMENT DETAILS VARIABLES*/
  payment_type = 2;
  paidBy = 1;
  config_channel: any;
  showing_balance: any;
  credit_error_msg: any;
  credit_no_book = false;
  credit_line_interval: any;
  soft_limit_error = false;
  hard_limit_error = false;
  show_booklater = false;
  window: any = window;
  // new booking variables
  pickupdate: any;
  dropdate: any;
  vehicletypeid: any;
  vehiclename: any;
  goodsttype: any;
  senderName: any;
  senderNumber: any;
  goodstypeId: any;
  goodstypeName: any;
  loadtype = 'LTL';
  pickupaddress: any;
  dropaddress: any;
  distance: any;
  distance_text: any;
  duration: any;
  duration_txt: any;
  metric_ton = 'Kg';
  pickup_city_name: any;
  drop_city_name: any;
  job_loader = false;
  agent_id: any;
  fileToUpload: File = null;
  timefee: any;
  distancefee: any;
  pickup_loader = false;
  imageapiUrl = `${myGlobals.apiurl}utility/uploadImage`;
  fareEstimateDetails: any;
  enableBidding = false;
  weightMetrics = [];
  dimensionUnit = 'ft';
  product_lgt = '';
  product_wid = '';
  product_ht = '';
  initialCountryCode: any;
  initialCountryFlag: any;
  senderCountrycode: any;
  walletEnable: any;
  accountType = 0;
  isCardEnable = false;
  isCashEnable = false;
  isWalletEnable = false;
  show_cards = false;
  allcards = [];
  addcard: any;
  defaultcard: any;
  disphome: any;
  card_number_all: any;
  visa = false;
  amex = false;
  discover = false;
  jcb = false;
  diners = false;
  master = false;
  card_cvc: any;
  card_month: any;
  card_year: any;
  walletPay = 0;
  showAllPayments = false;
  showWeight = true;
  currentVehicleCapacity: any;
  perHandlersPrice: number;
  finalHandlersPrice: any = 0;
  isPaidByReceiverEnable;
  isBookNowEnabled = false;
  isBookLaterEnabled = false;
  isReceiverConfirmationEnabled = true;
  isSecurityOtpIsEnabled = true;
  isBiddingEnabled: any;
  IsBookingCanBeDone = false;
  temp_finalAmount: any;
  handlersArr = [];
  IsPriceFixed = false;
  tripTimeInSeconds;
  currentVehicleCapacityInUnits;
  origin_autocomplete: any;
  destination_autocomplete: any;
  subscriptions: Subscription;
  allLanguages = [];
  defaultLanguage = 'en';
  isDimensionsEnabled = myGlobals.enableDimensions;
  languageTexts: any;
  onlineDrivers: any = [];
  cardsTransctionData: any;
  constructor(
    private _dispatcherService: DispatcherService,
    private _router: Router,
    private _MqttService: MqttService,
    private _conf: Configuration,
    private _cookie: ConfigService,
    private languageService: LanguageService,
    private translate: TranslateService,
    private sanitizer: DomSanitizer,
  ) {
    this._cookie.setItems('lang', 'en');
    this._MqttService.mqttConnection();
    let lang = this._cookie.getItem('lang');
    console.log('lang', lang);
    translate.getTranslation(lang).subscribe((res: string) => {
      // console.log("translate", res);
      this.languageTexts = res;
      //=> 'hello world'
    });
    this.getLanguages();
    // mqtt response
    this.subscriptions = _MqttService.missionAnnounced$.subscribe(
      (data: any) => {
        data = JSON.parse(data);
        // console.log('mqtt console', data);
        if (data.driverId != undefined) {
          if (data.status == 3) {
            if (this.onlineDrivers && this.onlineDrivers.length > 0) {
              let index = this.onlineDrivers.findIndex((item) => item.driverId == data.driverId);
              index <= -1 ? this.onlineDrivers.push(data) : '';
            }
            else {
              this.onlineDrivers.push(data);
            }
          }
          if (data.status == 9) {
            let index = this.onlineDrivers.findIndex((item) => item.driverId == data.driverId);
            index > -1 ? this.onlineDrivers.splice(index, 1) : '';
          }

        }
        else {

          if (data.status == 1) {
            if (data.hasOwnProperty('negotiation')) {
              if (data.negotiation.hasOwnProperty('status') == false) {
                data.status = 1;
              } else {
                data.status = data.negotiation.status;
              }
            }
          }
          console.log(data);
          const status = data.status;
          if (data && data.hasOwnProperty('transcationId')) {
            this.card_window.close();
            this.cardsTransctionData = data;
            toastr['success'](`<h5>${data['paymentText']}</h5>`);
            this.addinfo();
          }
          if (status === 16) {
            return;
          }
          if (status != 1) {
            $(`#notication_icon`)
              .addClass('animated swing')
              .one('animationend', function () {
                $(this).removeClass('animated swing');
              });
            this.increment_num++;
            const counterNumber = this.increment_num;
            $('#notification_bar').text(counterNumber);

            setTimeout(function () {
              $('#notification_bar').show();
            }, 200);
            const inputValue = (<HTMLMediaElement>(
              document.getElementById('audio')
            )).play();
            $('#notification_bar').addClass('active');
            $('#notification_ripple').addClass('active');
            window.setTimeout(() => {
              $('#notification_ripple').removeClass('active');
              $('#notification_bar').removeClass('active');
            }, 5000);
          }
          switch (status) {
            case 1:
              toastr['success'](`<h5>${this.languageTexts.swalTexts['newPost']}</h5>`);
              this.notifications.unshift(`${this.languageTexts.swalTexts['newPost']} ${data.bookingId}`);
              break;
            case 101:
              toastr['success']('<h5>' + data.negotiation.statusTxt + '</h5>');
              this.notifications.unshift(data.negotiation.statusTxt);
              break;
            case 102:
              toastr['success']('<h5>' + data.negotiation.statusTxt + '</h5>');
              this.notifications.unshift(data.negotiation.statusTxt);
              break;
            case 103:
              break;
            case 104:
              break;
            case 2:
              toastr['success'](
                `<h5> ${data.bookingId}  ${this.languageTexts.swalTexts['bookingAccept']}</h5>`
              );
              this.notifications.unshift(this.languageTexts.swalTexts['bookingAccept']);
              break;
            case 4:
            case 5: // driver started
            case 6: // driver on the way
              toastr['success'](
                '<h5><strong>Load Id :</strong> ' +
                data.bookingId +
                '<br><br>' +
                '<strong>status :</strong>' +
                data.statusText +
                '</h5>'
              );
              this.notifications.unshift(data.bookingId + ' ' + data.statusText);
              break;
            case 7: // driver arrived
              toastr['success'](
                '<h5><strong>Load Id :</strong> ' +
                data.bookingId +
                '<br><br>' +
                '<strong>status :</strong>' +
                data.statusText +
                '</h5>'
              );
              this.notifications.unshift(data.bookingId + ' ' + data.statusText);
              break;
            case 8: // driver loaded
            case 9: // trip started
              toastr['success'](
                '<h5><strong>Load Id :</strong> ' +
                data.bookingId +
                '<br><br>' +
                '<strong>status :</strong>' +
                data.statusText +
                '</h5>'
              );
              this.notifications.unshift(data.bookingId + ' ' + data.statusText);
              break;
            case 10: // reached to drop location
              toastr['success'](
                '<h5><strong>Load Id :</strong> ' +
                data.bookingId +
                '<br><br>' +
                '<strong>status :</strong>' +
                data.statusText +
                '</h5>'
              );
              this.notifications.unshift(data.bookingId + ' ' + data.statusText);
              break;
            case 11: //unloaded
              toastr['success'](
                '<h5><strong>Load Id :</strong> ' +
                data.bookingId +
                '<br><br>' +
                '<strong>status :</strong>' +
                data.statusText +
                '</h5>'
              );
              this.notifications.unshift(data.bookingId + ' ' + data.statusText);
              break;
            case 12: // completed
              toastr['success'](
                '<h5><strong>Load Id :</strong>' +
                data.bookingId +
                '<br><br>' +
                '<strong>status :</strong>' +
                data.statusText +
                '</h5>'
              );
              this.notifications.unshift(data.bookingId + ' ' + data.statusText);
              break;
            case 13: // expired
              toastr['success'](
                '<h5><strong>Load Id :</strong>' +
                data.bookingId +
                '<br><br>' +
                '<strong>status :</strong>' +
                data.msg +
                '</h5>'
              );
              this.notifications.unshift(data.bookingId + ' ' + data.msg);
              break;
            case 14: // booking bid timer expired
              toastr['success'](
                '<h5><strong>Load Id :</strong>' +
                data.bookingId +
                '<br><br>' +
                '<strong>status :</strong>' +
                data.msg +
                '</h5>'
              );
              this.notifications.unshift(data.bookingId + ' ' + data.msg);
              break;
            case 16: // driver unloaded
              break;
            case 10:
              break;
            case 30: // Wallet amount added
              toastr["success"](`<h5>${data.message}</h5>`);
              // this.notifications.unshift(data.message);
              break;
            case 17:
              swal({
                //this.languageTexts.swalTexts['enterWeight']
                title: this.languageTexts.swalTexts['reloadPageGoogle'],
                text:
                  this.languageTexts.swalTexts['areYouSure'],
                icon: 'warning',
                buttons: true,
                dangerMode: true
              }).then(willDelete => {
                if (willDelete) {
                  window.location.reload();
                } else {
                  swal(this.languageTexts.swalTexts['enterWeight']);
                }
              });
              break;
          }
        }
        // console.log('notificatiions--------->', this.notifications, this.onlineDrivers);
      }
    );
    setTimeout(() => {
      this.ngOnInit();
    }, 1000)
    // this.ngOnInit();
  }

  public onSubmitLogin(values: Object): void {
    this.submitted = true;

  }

  handleStatus(statuscode, error?) {
    console.log('handle status', statuscode, error);
    $('.modal').modal('hide');
    if (statuscode >= 500) {
      statuscode = 500;
    }
    switch (statuscode) {
      case 400:
        toastr['warning']('Bad request');
      case 401:
        // clearInterval(this.authorize_call);
        sessionStorage.removeItem('authtoken');
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem('phone');
        localStorage.removeItem('authToken');
        this._router.navigate(['login']);
        toastr['warning']('You have been logged out. Please login to continue');
        break;
      case 500:
        toastr['warning']('Could not connect to server');
        break;
    }
    if (error.message) {
      if (statuscode != 400 && statuscode != 401 && statuscode != 500) {
        toastr['warning'](error.message);
      }
    }
  }

  loggout() {
    this._dispatcherService
      .loggedout({
        userType: 1
      })
      .subscribe(
        (res: any) => {
          sessionStorage.removeItem('authtoken');
          sessionStorage.removeItem('userName');
          sessionStorage.removeItem('userName');
          sessionStorage.removeItem('phone');
          sessionStorage.removeItem('phone');
          localStorage.removeItem('authToken');
          this._router.navigate(['login']);
        },
        err => {
          const error = err.error;
          const listErr = error.statusCode;
          this.handleStatus(error.statusCode);
        }
      );
  }

  // weight validation by vivek

  weigthChange(e) {
    const inputWeightValue = parseFloat(e.target.value);
    const vehicleMaxWeight = parseFloat(this.currentVehicleCapacity);
    if (inputWeightValue > vehicleMaxWeight) {
      const weightEntered = inputWeightValue.toString();
      this.product_wgt = parseFloat(weightEntered.slice(0, -1));
      $('#wght_value').val(parseFloat(weightEntered.slice(0, -1)));
      // console.log(this.product_wgt);
      // console.log($('#wght_value').val());
      swal(
        'warning!',
        `${this.languageTexts.swalTexts['enterWeight']} ${vehicleMaxWeight} ${this.metric_ton}`,
        'error'
      );
    }
    setTimeout(() => {
      this.validate_form.element('#wght_value');
    }, 100);
  }

  notification() {
    $('#notification_body').toggle();
    $('#notification_bar').hide();
    $('#notification_bar').text(0);
    this.increment_num = 0;
  }

  myFunction() {
    const x = document.getElementById('snackbar');
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 3000);
  }
  onImageRemoved(e) {
    console.log(e);
    const response = e.serverResponse.response.body;
    const index = this.file.indexOf(response.data.url);
    if (index !== -1) {
      this.file.splice(index, 1);
    }
  }

  onUploadFinished(e) {
    console.log('onUploadFinished', e);
    const response = e.serverResponse.response.body;
    this.file.push(response.data.url);
  }
  change_fav_icn() {
    if ($('.mute_on').hasClass('fa-volume-up')) {
      $('.mute_on').removeClass('fa-volume-up');
      $('.mute_on').addClass('fa-volume-off');
      const aud_tag: any = document.getElementById('audio');
      aud_tag.src = '';
    } else {
      $('.mute_on').addClass('fa-volume-up');
      $('.mute_on').removeClass('fa-volume-off');
      const aud: any = document.getElementById('audio');
      aud.src = 'https://www.soundjay.com/transportation/sounds/car-honk-1.mp3';
    }
  }

  date_success() {
    $('.date_success_change').addClass('has-success');
  }

  // if same as sender is ticked then copy samething in receiver
  copyText(event, val) {
    if (val == 1) {
      this.senderNumber = event.target.value;
    }
    if ($('#sender_input').is(':checked')) {
      if (val == 0) {
        this.rec_name = this.senderName;
      } else {
        this.rec_number = this.senderNumber;
      }
      setTimeout(() => {
        this.validate_form.element('#receivername');
        this.validate_form.element('#receivernumber');
      }, 100);
    }
    console.log(this.senderNumber);
  }

  checkText(event, val) {
    if ($('#sender_input').is(':checked')) {
      if (this.rec_name !== this.senderName) {
        $('#sender_input').attr('checked', false);
      } else if (this.rec_number !== this.senderNumber) {
        $('#sender_input').attr('checked', false);
      }
      setTimeout(() => {
        this.validate_form.element('#receivername');
        this.validate_form.element('#receivernumber');
      }, 100);
    }
  }
  // Myself as sender
  myselfAssender() {
    if (event == undefined) {
      return;
    }
    event.preventDefault();
    const userName = sessionStorage.getItem('userName');
    const phone = sessionStorage.getItem('phone');
    if ($('#cbx').is(':checked')) {
      if (userName && phone) {
        this.senderName = userName;
        $('#sendernumber').val(phone);
        // this.senderNumber = parseInt(phone);
        $('#sendernumber').intlTelInput('setNumber', phone);
        setTimeout(() => {
          let mobile = $('#sendernumber').val();
          mobile = mobile.replace(/\s/g, '');
          // mobile = mobile.join();
          console.log(mobile);
          $('#sendernumber').val(mobile);
        }, 100);
        $('#sendernumber, #sendername').attr('disabled', true);
      }
    } else {
      $('#sendernumber, #sendername').attr('disabled', false);
      this.senderName = '';
      // this.senderNumber = '';
      $('#sendernumber').val('');
    }
    setTimeout(() => {
      this.validate_form.element('#sendername');
      this.validate_form.element('#sendernumber');
    }, 100);
    console.log(
      'this.senderName this.senderNumber',
      this.senderName,
      this.senderNumber
    );
  }
  // same as sender

  sameasSender() {
    this.senderNumber = $('#sendernumber').val();
    console.log(this.senderNumber);
    event.preventDefault();
    if ($('#sender_input').is(':checked')) {
      if (
        this.senderName != '' &&
        this.senderName != undefined &&
        this.senderNumber != undefined
      ) {
        const countryData = $('#sendernumber').intlTelInput(
          'getSelectedCountryData'
        ).dialCode;
        // const countryData_id = $("#sendernumber").intlTelInput("getSelectedCountryData").iso2;
        // const classes = $('.receiver_number_parent2 .iti-flag').attr('class').split(' ');
        // // console.log(classes);
        // $(".receiver_number_parent2 .selected-dial-code").text("+" + countryData);
        // $(".receiver_number_parent2 .iti-flag").removeClass(classes[1]);
        // $(".receiver_number_parent2 .iti-flag").addClass(countryData_id);
        // // $("#receivernumber").val('+'+countryData);
        // console.log("countrydataq---->", countryData, countryData_id);
        const senderNumber = $('#sendernumber').val();
        // console.log('sender name and number', senderNumber, countryData);
        const Number = `+${countryData}${senderNumber}`;
        $('#receivernumber').intlTelInput('setNumber', Number);
        this.rec_name = this.senderName;
        $('#sender_input').attr('checked', true);
        $('#receivernumber, #receivername').attr('disabled', true);
      } else {
        $('#sender_input').attr('checked', false);
        alert('please fill both sender name and number');
      }
    } else {
      this.rec_name = '';
      this.rec_number = '';
      $('#receivernumber').val('');
      $('#receivernumber, #receivername').attr('disabled', false);
    }
    setTimeout(() => {
      this.validate_form.element('#receivername');
      this.validate_form.element('#receivernumber');
    }, 100);
  }

  // change_payment(val) {
  //   $('#s-option'+val).trigger('click');
  //   this.payment_type = val;
  // }
  customerPayment(val) {
    console.log("value", val, this.IsBookingCanBeDone);
    if (val == 1) {
      // cash payment type
      $('#s-option4').trigger('click');
      this.credit_no_book = false;
      this.show_cards = false;
      this.payment_type = 2;
    } else if (val == 2) {
      // card payment type
      $('#s-option5').trigger('click');
      // this.getallcards();
      // this.show_cards = true;
      this.payment_type = 1;
      this.open_card_div();
      // if (this.approx_amount <= 0) {
      //   toastr['error']('Please fill all field before card payment');
      // }
    }
  }
  choosePrice: any;
  change_priceSelection(val, vehicleData,index) {
    console.log('val', val, event);
    if (val == 1) {
      $('#expressPriceOption' + index).trigger('click');
      $('.expressPriceOption' + index).show();
      $('.economyPriceOption' + index).hide();
      $('#est_journey').text(this.currency + vehicleData.finalAmount.toFixed(2));
      this.distancefee = this.fareEstimateDetails.distanceFee;
      this.distance = this.fareEstimateDetails.distance;
      this.timefee = this.fareEstimateDetails.timeFee;
      this.approx = this.fareEstimateDetails.finalAmount.toString();
      this.approx_amount = this.fareEstimateDetails.finalAmount;
      this.currency = this.fareEstimateDetails.currencySymbol;
      this.choosePrice = false;
    }
    else if (val == 2) {
      $('.economyPriceOption' + index).show();
      $('.expressPriceOption' + index).hide();
      $('#economyPriceOption' + index).trigger('click');
      $('#est_journey').text(this.currency + vehicleData.delivery.economyFee.toFixed(2));
      this.distancefee = this.fareEstimateDetails.distanceFee;
      this.distance = this.fareEstimateDetails.distance;
      this.timefee = this.fareEstimateDetails.timeFee;
      this.approx = vehicleData.delivery.economyFee.toString();
      this.approx_amount = vehicleData.delivery.economyFee;
      this.choosePrice = true;
    }
  }
  change_payment(val, event) {
    // event.stopPropagation();
    $('#s-option' + val).trigger('click');
    this.paidBy = val;
    console.log('customerPyament', val, event);
    if (val == 2) {
      $('#s-option4').trigger('click');
      $('#cbWalletBal').prop('checked', false);
      this.walletPay = 0;
      this.payment_type = 2;
      this.showAllPayments = false;
    } else {
      this.getallcards();
      this.walletPay = 0;
      this.payment_type = 2;
      this.showAllPayments = true;
    }
    // if (val == 1) {
    //   this.getallcards();
    // }
  }

  changeWallet() {
    const checkBool = $('#cbWalletBal').prop('checked');
    $('#cbWalletBal').prop('checked', !checkBool);
    if (!checkBool) {
      swal(
        'wallet!',
        this.languageTexts.swalTexts['carddeduct'],
        'warning'
      );
      this.walletPay = 1;
    } else {
      this.walletPay = 0;
    }
    // console.log("walletpay", this.walletPay);
  }
  checkWallet() {
    const checkBool = $('#cbWalletBal').prop('checked');
    if (checkBool) {
      swal(
        'wallet!',
        this.languageTexts.swalTexts['carddeduct'],
        'warning'
      );
      this.walletPay = 1;
    } else {
      this.walletPay = 0;
    }
    // console.log("walletpay", this.walletPay);
  }

  // BOOK NOW TIME WILL TAKE NOW TIME USING JAVASCRIPT
  book_now() {
    this.IsBookingCanBeDone = true;
    this.bookNow = false;
    //  $(".date_success_later").removeClass('has-success');
    $('#book_now_pop_button').addClass('active');
    $('.flatpickr').val('');
    this.appt_type = 1;
    this.addnew_job();
  }
  bookNow = false;
  book_now_trigger() {
    this.IsBookingCanBeDone = true;
    this.bookNow = true;
    $('#book_now_pop_button').addClass('active');
    $('.flatpickr').val('');
    this.addnew_job();
  }
  clearerror() {
    this.comment_error = false;
  }

  // LIVE BOOKING API
  addinfo() {
    if (this.IsBookingCanBeDone) {
      this.livebooking();
    }
  }

  checkBidding() {
    $('#switch').toggleClass('hover');
    this.enableBidding = !this.enableBidding;
    if (!this.enableBidding) {
      this.approx_amount = this.temp_finalAmount;
      console.log('changes valie', this.enableBidding, this.approx_amount, this.temp_finalAmount, this.finalHandlersPrice)
      this.priceChanged(this.approx_amount, true);
    }
  }

  livebooking() {
    if (this.approx_amount <= 0) {
      console.log('this.approx_amount=->', this.approx_amount);
      // swal('Error', 'Enter Valid Amount', 'error');
      return;
      // price = parseFloat(this.approx);
      // this.approx_amount = this.approx;
    }
    // console.log("moment", moment(this.pickupdate, 'YYYY-MM-DD HH:mm:ss'));
    this.job_loader = true;
    let pickupdate_timestamp, dropdate_timestamp;
    if (!this.bookNow) {
      pickupdate_timestamp = moment(
        this.pickupdate,
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD HH:mm:ss');
      dropdate_timestamp = moment(this.dropdate, 'YYYY-MM-DD HH:mm:ss').format(
        'YYYY-MM-DD HH:mm:ss'
      );
    }
    const receiverCountryCode = $('#receivernumber').intlTelInput(
      'getSelectedCountryData'
    ).dialCode;
    const senderCountryCode = $('#sendernumber').intlTelInput(
      'getSelectedCountryData'
    ).dialCode;
    const receiverNumber = $('#receivernumber').intlTelInput('getNumber', {
      nationalMode: false
    });
    console.log('receivernumber', receiverNumber);
    let length;
    let width;
    let height;
    const senderNumberWithCountryCode =
      '+' + senderCountryCode + $('#sendernumber').val();
    if (this.product_lgt != '') {
      length = this.product_lgt + this.dimensionUnit;
    } else {
      length = '';
    }
    if (this.product_ht != '') {
      height = this.product_ht + this.dimensionUnit;
    } else {
      height = '';
    }
    if (this.product_wid != '') {
      width = this.product_wid + this.dimensionUnit;
    } else {
      width = '';
    }
    if (this.product_qty == undefined) {
      this.product_qty = '';
    }
    $('.booking_loader_parent').show();
    $('.select_cards').removeClass('has-error');
    const devid = sessionStorage.getItem('devid');
    if (this.credit_no_book == true) {
      $('.booking_loader_parent').hide();
      $('#credit_popup_parent').show();
    } else {
      let cardId;
      if (this.payment_type == 1 && this.defaultcard != '') {
        cardId = this.defaultcard.id;
      } else {
        cardId = '';
      }

      if (this.payment_type == 1 && !this.cardsTransctionData && !this.cardsTransctionData.hasOwnProperty('transcationId')) {
        this.job_loader = false;
        // swal(
        //   'warning!',
        //   this.languageTexts.swalTexts['addCard'],
        //   'error'
        // );
        this.card_window ? this.card_window.close() : '';
        setTimeout(() => {
          this.open_card_div();
        }, 500);
        $('.booking_loader_parent').hide();
        // $('#credit_popup_parent').show();
        // this.card_window.close();
      } else {
        if (!this.showWeight) {
          this.product_wgt = this.currentVehicleCapacity;
          this.metric_ton = 'Kg';
        }
        if (this.IsPriceFixed) {
          this.approx_amount = this.approx;
        }
        let drop_time;
        if (this.bookNow) {
          drop_time = moment()
            .add(this.tripTimeInSeconds, 's')
            .format('YYYY-MM-DD HH:mm:ss');
        }
        let codamt = $('.codAmount').is(':checked');
        this._dispatcherService
          .postBooking({
            pickupAddress: this.pickupaddress.toString(),
            pickupLatitude: this.pickuplat.toString(),
            pickupLongitude: this.pickuplong.toString(),
            dropAddress: this.dropaddress.toString(),
            dropLatitude: this.droplat.toString(),
            dropLongitude: this.droplong.toString(),
            bookingDate: this.bookNow
              ? moment().format('YYYY-MM-DD HH:mm:ss')
              : pickupdate_timestamp,
            deliveryDate: this.bookNow ? drop_time : dropdate_timestamp,
            vehicleTypeId: this.vehicletypeid,
            vehicleType: this.vehiclename,
            receiverName: this.rec_name,
            receiverCountryCode: '+' + receiverCountryCode,
            receiverNumber: this.rec_number ? this.rec_number : receiverNumber,
            customerName: this.senderName,
            customerNumber: senderNumberWithCountryCode,
            goodTypeId: this.goodstypeId,
            goodTypeName: this.goodstypeName.trim(),
            loadType: this.loadtype,
            weight: this.product_wgt.toString(),
            deliveryFee: this.codAmount ? this.codAmount.toString() : '',
            weightUnit: this.metric_ton.toString(),
            isEconomy: this.choosePrice,
            // 'amount': this.approx_amount ? this.approx_amount.toString() : this.approx.toString(),
            amount: this.finalHandlersPrice
              ? this.finalHandlersPrice.toString()
              : this.approx.toString(),
            paidBy: this.paidBy,
            paymentType: this.payment_type,
            payByWallet: this.walletPay,
            extraNotes: this.product_det,
            cardId: cardId,
            estimateId: this.fareEstimateDetails.estimateId.toString(),
            // 'durationText': this.duration_txt,
            duration: this.duration,
            distance: this.distance,
            pickupCity: this.pickup_city_name,
            dropCity: this.drop_city_name,
            documents: this.file,
            bookingType: this.bookNow ? 1 : 2,
            deviceId: 'web',
            deviceType: 3,
            deviceTime: moment().format('YYYY-MM-DD HH:mm:ss'),
            timeFare: this.timefee,
            distFare: this.distancefee,
            serviceType: 1,
            // favoriteDriverId: this.favoriteDriverId,
            bidding: this.bookNow
              ? false
              : this.IsPriceFixed
                ? false
                : this.enableBidding,
            // 'length': length,
            // 'height': height,
            // 'width': width,
            handlers: this.handlers.toString()
            // 'quantity': this.product_qty
          })
          .subscribe(
            (res: any) => {
              this.IsBookingCanBeDone = false;
              $('.booking_loader_parent').hide();
              $('#myModal').modal('hide');
              $('#form1')[0].reset();
              this.IsPriceFixed = false;
              $('#approx_distance').text(`...`);
              swal(this.languageTexts.swalTexts['bookingCon'], this.languageTexts.swalTexts['orderSent'], 'success');
              this.job_loader = false;
              const data = {
                bookingId: res.data.bookingId,
                status: 1
              };
              console.log('JSON.stringify(data)', JSON.stringify(data));
              this.resetForm();
              // this._MqttService.announceMission(JSON.stringify(data));
            },
            err => {
              this.job_loader = false;
              $('.booking_loader_parent').hide();
              console.log(err);
              const error = err.error;
              if (err.status === 400) {
                swal('Warning', error.message, 'warning');
              } else {
                this.handleStatus(error.status, error);
                $('#approx_distance').text(`...`);
                $('#form1')[0].reset();
                $('#myModal').modal('hide');
              }
            }
          );
      }
    }
  }

  logged_out() {
    sessionStorage.removeItem('authtoken');
    sessionStorage.removeItem('userName');
    sessionStorage.removeItem('phone');
    this._router.navigate(['login']);
  }

  fileEvent(fileInput: any) {
    this.file = fileInput.target.files[0];
  }

  getmetricunit(e) {
    const weightValue = e.target.value;
    if (this.metric_ton != 'Kg' || weightValue != 'Kg') {
      this.product_wgt = '';
      $('#wght_value').val('');
      this.metric_ton = e.target.value;
      this.changeMaxWeight(this.metric_ton);
    }
    setTimeout(() => {
      this.validate_form.element('#wght_value');
    }, 100);
  }
  // TODO: Change the weight in placeholder as unit changes -- vivek
  changeMaxWeight(unit) {
    console.log(unit, this.currentVehicleCapacityInUnits);
    if (this.currentVehicleCapacityInUnits || !this.currentVehicleCapacityInUnits) {
      if (unit == 'Kg') {
        this.currentVehicleCapacity = this.currentVehicleCapacityInUnits.inKg;
      } else if (unit == 'Pound') {
        this.currentVehicleCapacity = this.currentVehicleCapacityInUnits.inPound;
      } else if (unit == 'Tonne') {
        this.currentVehicleCapacity = this.currentVehicleCapacityInUnits.inTonne;
      }
    }
  }
  // price based on handlers 0--vivek
  getHandlers(e) {
    this.handlers = e.target.value;
    const handlers = parseInt(e.target.value);
    const handlerPrice = handlers * this.perHandlersPrice;
    const initialPrice = parseFloat(this.approx);
    // this.approx = this.approx_amount;
    // this.approx_amount = parseFloat(this.approx) + handlerPrice;
    const temp = parseFloat(this.approx_amount);
    if (!isNaN(temp)) {
      this.finalHandlersPrice = parseFloat(this.approx_amount) + handlerPrice;
      this.finalHandlersPrice = this.finalHandlersPrice.toFixed(2);
    }
    console.log(
      'No of Handlers && Price-->',
      this.finalHandlersPrice,
      handlers,
      this.approx_amount,
      handlerPrice
    );
  }

  priceChanged(e, trigger = false) {
    // console.log('price chnaged', e.target.value)
    // if (!trigger) {
    const price = parseInt(e.target.value);
    if (price <= 0) {
      swal('Error', this.languageTexts.swalTexts['enterValidAmt'], 'error');
    } else
      if (!isNaN(price)) {
        const handlerPrice = this.handlers * this.perHandlersPrice;
        this.finalHandlersPrice = price + handlerPrice;
        this.finalHandlersPrice = this.finalHandlersPrice.toFixed(2);
      }
      // }
      // } 
      else {
        const handlerPrice = this.handlers * Number(this.perHandlersPrice);
        this.finalHandlersPrice =
          Number(this.temp_finalAmount) + Number(handlerPrice);
        // this.finalHandlersPrice = this.finalHandlersPrice.toFixed(2);
      }
  }
  onChange(event) {
    console.log('in the booking');
    const event_file = event;
    let file_name = $('#file_input').val();
    file_name = file_name.replace(/[{()}]/g, '');
    const regex = /^([a-zA-Z0-9\s_\\.:])+(.csv|.txt|.xlsx)$/;
    if (regex.test(file_name.toLowerCase())) {
      if (typeof FileReader != 'undefined') {
        const reader = new FileReader();
        reader.onload = e => {
          const file = event_file.srcElement.files;
          const postData = {
            ent_sess_token: localStorage.getItem('authToken'),
            ent_dev_id: localStorage.getItem('devid')
          }; // Put your form data variable. This is only example.
          $('#file_input').val('');
          $('#bulk_close_btn').trigger('click');
        };
        reader.readAsText($('#file_input')[0].files[0]);
      } else {
        alert('This browser does not support HTML5.');
      }
    } else {
      alert('Please upload a valid CSV file.');
      $('#file_input').val('');
      $('#file_input').focus();
    }
  }

  show_raing_txt(rate) {
    this.show_highrate_comment = false;
    this.high_rating = '';
    this.rating_num = rate;
    this.show_select = false;
    this.rating_error = false; // hide error if any
    if (rate < 4) {
      $('input[name=selector_review]').val(
        $('input[name=selector_review] option:first').val()
      );
      this.rating_text = [];
      this.show_low_rating = true;
      this.show_high_rating = false;
      for (const key in this.driver_rating) {
        if (key == rate) {
          this.rating_text = this.driver_rating[key];
          break;
        }
      }
    } else {
      this.rating_text = [];
      this.show_low_rating = false;
      this.show_high_rating = true;
      this.show_select = true;
      for (const key in this.driver_rating) {
        if (key == rate) {
          this.rating_text = this.driver_rating[key];
          break;
        }
      }
    }
  }

  callsingalbooking(bid) {
    this._dispatcherService
      .getdet({
        ent_page_index: '0',
        ent_booking_id: bid
      })
      .subscribe(
        (res: any) => {
          // console.log('singalbooking+++++++++++', res);
          if (res.errFlag == 0) {
            this.rating_b_details = res.data.appointments[0];
            console.log(
              'singalbooking+++++++++++rating_b_details',
              this.rating_b_details
            );
            setTimeout(() => {
              $('#review_popup').modal({ backdrop: 'static', keyboard: false });
            }, 200);
            console.log('rating_b_details', this.rating_b_details);
          } else {
            alert(res.errMsg);
          }
        },
        err => {
          const error = err.error;
          const listErr = error.statusCode;
          this.handleStatus(error.statusCode, error);
        }
      );
  }

  // trigger a function when vehicletypes changes and stores id and name in variables
  // for post jobs service
  // and for getting goodstypes list variable to reflect on booking popup

  get_vehicletypes(vehicleData,index) {
    // const vehicletypeid = $('#vehicle_types option:selected').val();
    const vehicletypeid = $(`input[name='vehicleType']:checked`).val();
    this.vehicletypeid = vehicletypeid;
    console.log(this.vehicle_types);
    this.fareEstimate(vehicleData);
    this.getVehicles();
    // this.getFavoriteDriver();
    this.vehicle_types.map((vehicleItem) => {
      vehicleItem['checked'] = false;
    });
    this.vehicle_types[index].checked = true;
    setTimeout(() => {
      this.change_priceSelection(1, this.vehicle_types[index], index);
    }, 1000);
    for (let goods = 0; goods < this.vehicle_types.length; goods++) {
      if (this.vehicle_types[goods]._id == vehicletypeid) {
        // this.vehicle_types[goods].checked = true;
        this.goods_type_list = this.vehicle_types[goods].goodTypesName;
        this.vehicletypeid = this.vehicle_types[goods]._id;
        this.vehiclename = this.vehicle_types[goods].type_name;
        break;
      }
    }
  }
  favoriteDrivers: any;
  favoriteDriverId: any;
  getFavoriteDriver() {
    this.favoriteDrivers = [];
    this._dispatcherService
      .getFavoriteDriversBasedOnVehicle({
        vehicleTypeId: this.vehicletypeid
      })
      .subscribe(
        (res: any) => {
          for (let inst = 0; inst < res.data.length; inst++) {
            this.favoriteDrivers.push(res.data[inst]);
            // let index = this.onlineDrivers.findIndex((item) => item.driverId == res.data[inst].masterId);
            // index > -1 ? this.onlineDrivers.splice(index, 1) : '';
            // console.log('goods_type_list', res);
          };
          this.onlineDrivers.map((item, i) => {
            if (item.status == 9) {
              let index = this.favoriteDrivers.findIndex((x) => x.masterId == item.driverId);
              index > -1 ? this.favoriteDrivers.splice(index, 1) : '';
            }
          })
        },
        err => {
          const error = err.error;
          const listErr = error.statusCode;
          this.favoriteDrivers = [];
          this.handleStatus(error.statusCode, error);
        }
      );
  }
  get_favoriteDriver(value) {
    this.favoriteDriverId = $(`input[name='favoriteDriver']:checked`).val();
  }

  goodschange() {
    const goodstype = $('#goodstype_selection option:selected').val();
    this.goodstypeId = goodstype;
    this.goodstypeName = $('#goodstype_selection option:selected').text();
    console.log(this.goodstypeId);
    console.log(this.goodstypeName);
  }
  scathelChanges() {
    const scatchelValue = $('#scatchelType_selection option:selected').val();
    console.log('dsjknfjkdf', scatchelValue);
    this.fareEstimateDetails.finalAmount = parseFloat(scatchelValue).toFixed(2);
    this.approx_amount = parseFloat(scatchelValue).toFixed(2);;
    this.temp_finalAmount = parseFloat(scatchelValue).toFixed(2);;
  }
  change_qty(val) {
    if (val == 0) {
      this.loadtype = 'LTL';
      $('#f-option1').trigger('click');
      this.showWeight = true;
      this.changeMaxWeight('Kg');
      this.metric_ton = 'Kg';
    } else {
      this.loadtype = 'FTL';
      this.showWeight = false;
      $('#f-option2').trigger('click');
      this.changeMaxWeight('Kg');
      this.metric_ton = 'Kg';
    }
  }

  currentlat() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        e => {
          this.current_lat = e.coords.latitude;
          this.current_lng = e.coords.longitude;
        },
        err => {
          console.log(err);
          jQuery.get(
            'https://ipinfo.io',
            response => {
              this.current_lat = response.loc.split(',')[0];
              this.current_lng = response.loc.split(',')[1];
            },
            'jsonp'
          );
        }
      );
    } else {
      jQuery.get(
        'https://ipinfo.io',
        response => {
          this.current_lat = response.loc.split(',')[0];
          this.current_lng = response.loc.split(',')[1];
        },
        'jsonp'
      );
    } // get current lat long using ipinfo
  }

  removepickupmarker() {
    // remove pickupmarker
    if (this.pickup_marker_loc) {
      this.pickup_marker_loc.setMap(null);
    }
  }

  removeMarkers() {
    // console.log(this.directionsDisplay, this.drop_marker_loc);
    if (this.directionsDisplay) {
      this.directionsDisplay.setMap(null);
    }
    if (this.drop_marker_loc) {
      this.drop_marker_loc.setMap(null);
    }
    if (this.pickup_marker_loc) {
      this.pickup_marker_loc.setMap(null);
    }
  }

  showpickupmarker() {
    // show pickupmarker
    const pos = new google.maps.LatLng(this.pickuplat, this.pickuplong);
    this.pickup_marker_loc = new google.maps.Marker({
      position: pos,
      icon: myGlobals.pickupicn,
      map: this.map,
      draggable: true
    });
    if (this.droplat && this.droplong) {
      this.drawroute();
    }
    google.maps.event.addListener(this.pickup_marker_loc, 'dragend', () => {
      this.pickuplat = this.pickup_marker_loc.position.lat();
      this.pickuplong = this.pickup_marker_loc.position.lng();
      this.checkpickup();
    });
    this.mappickup_drop_bounds = new google.maps.LatLngBounds();
    this.mappickup_drop_bounds.extend(this.pickup_marker_loc.getPosition());
    this.map.fitBounds(this.mappickup_drop_bounds);
    this.map.setZoom(18);
  }

  // Fare Estimate All fun to get all vehicel fare's by Vivek on 20/jun/2019
  fareEstimateAll() {
    // console.log(this.pickuplat, this.pickuplong, this.droplat, this.droplong);
    if (this.pickuplat && this.pickuplong && this.droplat && this.droplong) {
      $(`#orbit-spinner`).fadeIn();
      this._dispatcherService
        .fareEstimateAll({
          pickupLatLong:
            this.pickuplat.toString() + ',' + this.pickuplong.toString(),
          dropLatLong: this.droplat.toString() + ',' + this.droplong.toString(),
          pickup: this.pickupaddress.toString(),
          drop: this.dropaddress.toString(),
          bookingType: this.bookNow ? 1 : 2,
          serviceType: 1
        })
        .subscribe(
          (res: any) => {
            console.log('fareEstimateAll', res);
            this.fareEstimateDetails = res.data;
            this.distance = res.data.distance;
            res.data.vehicleTypeArray.map((item) => {
              item.finalAmount = parseFloat(item.finalAmount);
              item.delivery.economyFee = parseFloat(item.delivery.economyFee);
              item['checked'] = false;
            });
            this.vehicle_types = res.data.vehicleTypeArray;
            this.currency = res.data.currencySymbol;
            this.perHandlersPrice = res.data.perHandlersPrice;
            this.tripTimeInSeconds = res.data.tripTimeInSeconds;
            this.duration = res.data.duration;
            this.handlersArr = [];
            for (let index = 1; index <= 10; index++) {
              const temp = `${index} ${this.languageTexts.disp['handlers']}  @ ${this.currency} ${index *
                this.perHandlersPrice}`;
              this.handlersArr.push(temp);
            }
            $('#approx_distance').text(
              `${res.data.distance} ${res.data.distanceMetrics}`
            );
            $(`#orbit-spinner`).fadeOut();
            setTimeout(() => {
              $(`#vehicleTypeContainer`).trigger('click');
            }, 400);
          },
          err => {
            const error = err.error;
            this.handleStatus(error.statusCode, error);
          }
        );
    }
  }
  selectedVehicleData: any;
  ScatchelsData: any = [];
  fareEstimate(vehicleData?) {
    // console.log(vehicleData);
    // this.IsPriceFixed = false;
    // this.distancefee = vehicleData.distanceFee;
    // this.timefee = vehicleData.timeFee;
    // this.IsPriceFixed = vehicleData.fixedPriceApplied === 1 ? true : false;
    // this.approx = vehicleData.finalAmount.toString();
    // this.approx_amount = vehicleData.finalAmount;
    // this.temp_finalAmount = vehicleData.finalAmount;
    // $('#est_journey').text(this.currency + vehicleData.finalAmount);
    // this.currentVehicleCapacity = vehicleData.vehicleCapacityInUnits.inKg;
    // this.currentVehicleCapacityInUnits = vehicleData.vehicleCapacityInUnits;
    // this.product_wgt = '';
    // $('#wght_value').val('');
    // this.metric_ton = 'Kg';
    // $('#weight_units>option:eq(0)').prop('selected', true);


    this.fareEstimateDetails = [];
    this._dispatcherService.fareEstimate({
      'pickupLatLong': this.pickuplat.toString() + ',' + this.pickuplong.toString(),
      'dropLatLong': this.droplat.toString() + ',' + this.droplong.toString(),
      'pickup': this.pickupaddress.toString(),
      'drop': this.dropaddress.toString(),
      'bookingType': this.bookNow ? 1 : 2,
      'vehicleTypeId': this.vehicletypeid,
      'serviceType': 1
    }).subscribe((res) => {
      console.log('fareestimate', res);
      this.fareEstimateDetails = res['data'];
      if ( this.fareEstimateDetails.isSpecialCustomer && this.fareEstimateDetails.satchelDetails && this.fareEstimateDetails.satchelDetails.length > 0) {
        this.fareEstimateDetails.satchelDetails.map((item) => {
          if (item.product && item.product.length > 0) {
            item.product.map((productItem) => {
              if (productItem.Price && productItem.productName) this.ScatchelsData.push(productItem);
            });
           }
        });
        console.log('this.ScatchelsData', this.ScatchelsData);
      }
      if (this.fareEstimateDetails.isSpecialCustomer) {
        this.fareEstimateDetails.finalAmount = '';
      }
      this.perHandlersPrice = res['data'].perHandlersPrice;
      this.tripTimeInSeconds = res['data'].tripTimeInSeconds;
      this.IsPriceFixed = res['data'].fixedPriceApplied === 1 ? true : false;
      this.distance = res['data'].distance;
      this.approx_amount = '';
      // if (parseFloat(res['data'].finalAmount) > parseFloat(res['data'].vehicleTypeDetails.delivery.economyFee)) {
      //   this.distancefee = res['data'].distanceFee;
      //   this.timefee = res['data'].timeFee;
      //   this.approx = res['data'].finalAmount.toString();
      //   this.approx_amount = res['data'].finalAmount;
      //   $('#est_journey').text(res['data'].currencySymbol + res['data'].finalAmount);
      // }
       this.currency = res['data'].currencySymbol;
      $('#approx_distance').text(`${res['data'].distance} ${res['data'].distanceMetrics}`);
      const vehicleId = this.vehicletypeid;
      const vechiclesData = this.vehicle_types;
      const currentVehicleData: any = vechiclesData.filter(data => data.typeId == vehicleId);
      this.currentVehicleCapacity = currentVehicleData[0].vehicleCapacityInUnits.inKg;
      this.currentVehicleCapacityInUnits = currentVehicleData[0].vehicleCapacityInUnits;
      this.product_wgt = '';
      $('#wght_value').val('');
      this.metric_ton = 'Kg';
      $('#weight_units>option:eq(0)').prop('selected', true);
    }, (err) => {
      var error = err.error
      var listErr = error.statusCode;
      this.handleStatus(error.statusCode, error);
    }
    );
  }
  getVehicles() {
    this.goods_type_list = [];
    this._dispatcherService
      .getGoodstypes({
        vehicleTypeId: this.vehicletypeid
      })
      .subscribe(
        (res: any) => {
          for (let inst = 0; inst < res.data.length; inst++) {
            this.goods_type_list.push(res.data[inst]);
            // console.log('goods_type_list', res);
          }
        },
        err => {
          const error = err.error;
          const listErr = error.statusCode;
          this.handleStatus(error.statusCode, error);
        }
      );
  }

  // check for pickup
  checkzone_one() {
    this.isCardEnable = false;
    this.isCardEnable = false;
    this.isWalletEnable = false;
    this.vehicle_types = []; // checkfor pickupzone
    $("label[for='origin-input2']").text('Checking location'); // alert message
    $('#map_loader_parent').show(); // loader showing
    this.clear_all_distance();
    this._dispatcherService
      .zone({
        latitude: this.pickuplat,
        longitude: this.pickuplong,
        mqttTopic: this._conf.getItem('mqtt')
      })
      .subscribe(
        (res: any) => {
          if (res.data.vehicleTypes.length > 0) {
            // this.showAllPayments = true;
            this.isCardEnable = res.data.cityData.isCardEnable;
            this.isCashEnable = res.data.cityData.isCashEnable;
            this.isPaidByReceiverEnable =
              res.data.cityData.isPaidByReceiverEnable;
            this.isWalletEnable = res.data.walletData.isWalletEnable;

            // for (let inst = 0; inst < res.data.vehicleTypes.length; inst++) {
            //   this.vehicle_types.push(res.data.vehicleTypes[inst]);
            // }
            console.log(res);
            this.removepickupmarker();
            $("label[for='origin-input2']").remove();
            $('#map_loader_parent').hide();
            this.pickup_loader = false;
            if (res.errFlag == 1) {
              this.pickup_bool = false;
              this.showAllPayments = false;
              $('#origin-input2')
                .closest('.form-group')
                .removeClass('has-success')
                .addClass('has-error');
              $('#error_popup_parent').show();
              $('#origin-input2').val('');
              $('#origin-input2').focus('');
            } else {
              this.pickup_bool = true;
              this.pickup_loc_bool = true;
              this.showpickupmarker();
            }
          } else {
            this.pickup_loc_bool = false;
            this.pickup_bool = false;
            this.removepickupmarker();
            $('#map_loader_parent').hide();
            $('#error_popup_parent').show();
            this.pickup_loader = false;
            $('#origin-input2').val('');
            $("label[for='origin-input2']").text('Please enter valid location');
            $('#origin-input2')
              .closest('.form-group')
              .removeClass('has-success')
              .addClass('has-error');
          }
        },
        err => {
          console.log('responese------->', err);
          const error = err.error;
          const listErr = error.statusCode;
          this.handleStatus(error.statusCode, error);
        }
      );
  }

  checkzone_two() {
    // checkfor droptwo  and draw lat longs
    $("label[for='origin-input3']").text('Checking location');
    $('#map_loader_parent').show();
    this.clear_all_distance();
    this._dispatcherService
      .zone({
        latitude: this.droplat,
        longitude: this.droplong,
        mqttTopic: this._conf.getItem('mqtt')
      })
      .subscribe(
        (res: any) => {
          console.log(res);
          $(`label[for='origin-input3']`).remove();
          $('#map_loader_parent').hide();
          $('.loader_place2').hide();
          if (res.data.vehicleTypes.length == 0) {
            $('#origin-input3')
              .closest('.form-group')
              .removeClass('has-success')
              .addClass('has-error');
            $('#error_popup_parent').show();
            $('#origin-input3').val('');
            $('#origin-input3').focus('');
          } else {
            this.drawroute();
            this.drop_loc_bool = true;
            $('#origin-input3')
              .closest('.form-group')
              .removeClass('has-error')
              .addClass('has-success');
            if (this.pickup_bool && this.drop_bool) {
              this.vehicle_type_load = true;
            }
          }
        },
        err => {
          const error = err.error;
          const listErr = error.statusCode;
          this.handleStatus(error.statusCode, error);
        }
      );
  }

  checkpickup() {
    // when marker on map moved get location
    const geocoder = new google.maps.Geocoder();
    const infowindow = new google.maps.InfoWindow();
    const latlng = {
      lat: parseFloat(this.pickuplat),
      lng: parseFloat(this.pickuplong)
    };
    geocoder.geocode({ location: latlng }, (results, status) => {
      console.log('results', results);
      if (status === 'OK') {
        if (results[0]) {
          this.map.setZoom(11);
          $('#origin-input2').val(results[0].formatted_address);
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }

      if (this.droplat && this.droplong) {
        this.drawroute();
      }
      this.checkzone_one();
    });
  }

  drawroute() {
    $('.loader_place2').hide();
    console.log('drawroutes');
    this.clear_all_distance(); // Clear all the vechicles when changing pickup or drop
    const origin = new google.maps.LatLng(this.pickuplat, this.pickuplong); // using pickuplat
    const destination = this.droplat + ', ' + this.droplong; // using droplat long
    const directionsService2 = new google.maps.DirectionsService({
      preserveViewport: true
    });
    const request = {
      origin: origin, // LatLng|string
      destination: destination, // LatLng|string
      travelMode: google.maps.DirectionsTravelMode.DRIVING // TRAVEL MODE
    };
    directionsService2.route(request, (response, status) => {
      if (status === 'OK') {
        const trip_distance = response.routes[0].legs[0].distance;
        const trip_time = response.routes[0].legs[0].duration;
        // this.distance = trip_distance.value;
        this.distance_text = trip_distance.text;
        // this.duration = trip_time.value;
        this.duration_txt = trip_time.text;
        const point = response.routes[0].legs[0]; // SHOWING MAP ROUTE ZOOM BASED ON APPROX DIST
        this.journey_time = point.distance.value;
        this.journey_time = this.journey_time / 1000;
        this.directionsDisplay.setDirections(response);
        this.directionsDisplay.setMap(this.map); // DRAWING MAP ROUTES FROM PICKUP AND DROP FROM RESULT
        const zoomChangeBoundsListener = google.maps.event.addListenerOnce(
          this.map,
          'bounds_changed',
          event => {
            this.map.panToBounds(this.mappickup_drop_bounds);
            if (this.journey_time <= 100) {
              this.map.setZoom(12);
            } else if (this.journey_time > 100 && this.journey_time < 500) {
              this.map.setZoom(8);
            } else if (this.journey_time > 500 && this.journey_time < 1500) {
              this.map.setZoom(6);
            } else if (this.journey_time > 1500) {
              this.map.setZoom(5);
            }
            google.maps.event.trigger(this.map, 'resize');
          }
        );
        setTimeout(function () {
          google.maps.event.removeListener(zoomChangeBoundsListener);
        }, 1000);
      }
    });

    // END OF TIME CALCULATION GOOGLE API
  }

  change_dimensions_unit() {
    const selected_value = $('select#dimenstions')
      .children(':selected')
      .val();
    this.dimensionUnit = selected_value;
  }
  checkdrop() {
    console.log('alldetailsdroppin');
    const geocoder = new google.maps.Geocoder();
    const infowindow = new google.maps.InfoWindow();
    const latlng = {
      lat: parseFloat(this.droplat),
      lng: parseFloat(this.droplong)
    };
    geocoder.geocode({ location: latlng }, (results, status) => {
      console.log('results', results);
      if (status === 'OK') {
        if (results[0]) {
          this.map.setZoom(11);
          $('#origin-input3').val(results[0].formatted_address);
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }
      this.drawroute();
      this.drop_loc_bool = true;
      $('#origin-input3')
        .closest('.form-group')
        .removeClass('has-error')
        .addClass('has-success');
      if (this.pickup_bool && this.drop_bool) {
        this.vehicle_type_load = true;
      }
      $("label[for='origin-input3']").remove();
      $('#map_loader_parent').hide();
      $('.loader_place2').hide();
      // this.checkzone_two()
      this.drop_loc_bool = true;
      $('#origin-input3')
        .closest('.form-group')
        .removeClass('has-error')
        .addClass('has-success');
      if (this.pickup_bool && this.drop_bool) {
        this.vehicle_type_load = true;
        // this.getVechicles();
        console.log('intialted');
      }
    });
  }
  clear_all_distance() {
    this.distance_text = '....';
    this.duration_txt = '....';
  }
  //   clear_all_vehicles() {
  //     this.vehicle_types = [];
  //     this.duration = [];
  //     this.approx_dist_txt = [];
  //     this.approx = [];
  // }

  get_dates(laterTime) {
    // console.log(laterTime);
    this.current_time = new Date();
    this.current_time_var =
      this.current_time.getFullYear() +
      '-' +
      ('0' + (this.current_time.getMonth() + 1)).slice(-2) +
      '-' +
      this.current_time.getDate() +
      ' ' +
      this.current_time.getHours() +
      ':' +
      this.current_time.getMinutes() +
      ':' +
      this.current_time.getSeconds();
    const startDate = moment().add(parseInt(laterTime), 'seconds');
    // console.log(
    //   '--- DAte------------>',
    //   startDate,
    //   laterTime,
    //   moment(startDate).format('YYYY-MM-DD HH:mm:ss')
    // );
    flatpickr('.flatpickr', {
      // defaultDate: moment(startDate).format('YYYY-MM-DD HH:mm:ss'), // Date objects and date strings are also accepted
      enableTime: true,
      minDate: moment(startDate).format('YYYY-MM-DD HH:mm:ss'), // "today" / "2016-12-20" / 1477673788975
      altInput: true,
      onChange: () => {
        setTimeout(() => {
          let calendar = $('.flatpickr').val();
          calendar = moment(calendar).add(this.tripTimeInSeconds, 's');
          calendar = moment(calendar).format('YYYY-MM-DD HH:mm:ss');
          console.log('calender==>>', calendar);
          // this.validate_form.element('.flatpickr');
          flatpickr('.flatpickr2', {
            // defaultDate: moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
            minDate: calendar, // Date objects and date strings are also accepted
            enableTime: true,
            altInput: true,
            onChange: () => {
              // this.validate_form.element('.flatpickr2');
            }
          });
        }, 500);
      }
    });
    flatpickr('.flatpickr2', {
      // defaultDate: moment(startDate).format('YYYY-MM-DD HH:mm:ss'), // Date objects and date strings are also accepted
      enableTime: true,
      minDate: moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
      // altFormat: 'M j, Y',
      altInput: true,
      onChange: () => { }
    });
    this.pickupdate = '';
  }

  initMap() {
    const userLocation = {
      lat: this.current_lat ? this.current_lat : 12.9716,
      lng: this.current_lng ? this.current_lng : 77.5946
    };
    this.map = new google.maps.Map(document.getElementById('map2'), {
      center: userLocation,
      zoom: 20,
      disableDefaultUI: true,
      zoomControl: true,
      scaleControl: true,
      styles: mapStyle[0],
      minZoom: 2,
      maxZoom: 20
    });

    const directionsDisplay = new google.maps.DirectionsRenderer({
      suppressMarkers: true
    });
    directionsDisplay.setMap(this.map);
    const origin_input = document.getElementById('origin-input2');
    const destination_input = document.getElementById('origin-input3');
    this.origin_autocomplete = new google.maps.places.Autocomplete(
      origin_input
    );
    this.origin_autocomplete.bindTo('bounds', this.map);
    this.origin_autocomplete.addListener('place_changed', () =>
      this.origin_autocomplete_handler()
    );
    this.destination_autocomplete = new google.maps.places.Autocomplete(
      destination_input
    );
    this.destination_autocomplete.bindTo('bounds', this.map);
    this.destination_autocomplete.addListener('place_changed', () =>
      this.destination_autocomplete_handler()
    );
  }

  origin_autocomplete_handler() {
    $('#vehicle_types').prop('selectedIndex', 0);
    $('.flatpickr').val('');
    $('.flatpickr2').val('');
    this.pickupdate = '';
    this.dropdate = '';
    const place = this.origin_autocomplete.getPlace();
    console.log(place);
    for (
      let city_add = 0;
      city_add < place.address_components.length;
      city_add++
    ) {
      if (place.address_components[city_add].types[0] == 'locality') {
        this.pickup_city_name = place.address_components[city_add].long_name;
        break;
      }
    }
    this.pickuplat = place.geometry.location.lat();
    this.pickuplong = place.geometry.location.lng();
    this.checkzone_one();
    this.vehicles_empty = false;
    this.current_lat = place.geometry.location.lat();
    this.current_lng = place.geometry.location.lng();
    this.pickup_loader = true;
    $('#origin-input2')
      .closest('.form-group')
      .removeClass('has-error')
      .addClass('has-success');
    $(`label[for='origin-input3']`).remove();
    this.pickup_bool = true;
    this.show_error_bool = true;
    this.checking_vehs = true;
    this.pickupaddress = place.formatted_address;
    this.fareEstimateAll();
  }

  destination_autocomplete_handler() {
    $('#vehicle_types').prop('selectedIndex', 0);
    $('.flatpickr').val('');
    $('.flatpickr2').val('');
    this.pickupdate = '';
    this.dropdate = '';
    const place = this.destination_autocomplete.getPlace();
    this.droplat = place.geometry.location.lat();
    this.droplong = place.geometry.location.lng();
    this.dropaddress = place.formatted_address;
    this.fareEstimateAll();
    console.log(place);
    for (
      let city_add = 0;
      city_add < place.address_components.length;
      city_add++
    ) {
      if (place.address_components[city_add].types[0] == 'locality') {
        this.drop_city_name = place.address_components[city_add].long_name;
        break;
      }
    }
    $(`label[for='origin-input3']`).text('Checking location');
    if (this.drop_marker_loc) {
      // if any previous drop marker remove that markers
      this.drop_marker_loc.setMap(null);
    }
    $('.loader_place2').show();
    this.drawroute();
    this.drop_loc_bool = true;
    $('#origin-input3')
      .closest('.form-group')
      .removeClass('has-error')
      .addClass('has-success');
    if (this.pickup_bool && this.drop_bool) {
      this.vehicle_type_load = true;
    }
    $(`label[for='origin-input3']`).remove();
    $('#map_loader_parent').hide();

    // this.checkzone_two();
    const veh_id = $('input[name=radio]:checked').attr('value');
    console.log(veh_id);

    this.drop_bool = true;
    const pos = new google.maps.LatLng(this.droplat, this.droplong);
    this.drop_marker_loc = new google.maps.Marker({
      position: pos,
      icon: myGlobals.dropupicn,
      map: this.map,
      draggable: true
    });
    google.maps.event.addListener(this.drop_marker_loc, 'dragend', () => {
      this.droplat = this.drop_marker_loc.position.lat();
      this.droplong = this.drop_marker_loc.position.lng();
      this.checkdrop();
      // document.getElementById('lng').value = marker.position.lng();
    });
    this.mappickup_drop_bounds.extend(this.drop_marker_loc.getPosition());
  }

  addnew_job() {
    this.resetForm();
    this.currentlat();
    setTimeout(() => {
      const userLocation = {
        lat: -28.4793,
        lng: 24.6727
        // lat: this.current_lat ? this.current_lat : 12.9716,
        // lng: this.current_lng ? this.current_lng : 77.5946
      };
      this.map.setCenter(userLocation);
      this.map.setZoom(5);
      // console.log(this.map);
      // console.log('currentPosition--->', userLocation);
      // this.wallet();
      this.wallet();
      this.appconfig();
      // this.get_dates();
      this.getallcards();
      $('.popup_left_div').animate({ scrollTop: 0 }, 100); // scrolls to top
      const popup_ht = $('.popup_left_div').height(); // takes height of popup
      $('.popup_right_div').css('height', popup_ht); // gives height to popup right div
    }, 300);
    this.myselfAssender();
    // const userName = sessionStorage.getItem('userName');
    // const phone = sessionStorage.getItem('phone');
    // if (userName && phone) {
    //   this.senderName = userName;
    //   $("#sendernumber").val(phone);
    //   // this.senderNumber = parseInt(phone);
    //   $("#sendernumber").intlTelInput("setNumber", phone);
    //   setTimeout(() => {
    //     let mobile = $("#sendernumber").val();
    //     mobile = mobile.replace(/\s/g, '');
    //     // mobile = mobile.join();
    //     console.log(mobile);
    //     $("#sendernumber").val(mobile);
    //   }, 100);
    //   $('#sendernumber, #sendername').attr('disabled', true);
    // }
    // setTimeout(() => {
    //   this.validate_form.element('#sendername');
    //   this.validate_form.element('#sendernumber');
    // }, 1000);
  }

  card_wallet_validate() {
    // add new card wallet validation
    $('#credit_form_validation').validate({
      rules: {
        username: {
          minlength: 3,
          required: true
        },
        month: {
          required: true
        },
        card_name: {
          required: true
        },
        cvv: {
          minlength: 3,
          required: true
        }
      },
      success: element => { },
      highlight: function (element) {
        $(element)
          .closest('.form-group')
          .removeClass('has-success')
          .addClass('has-error');
        $(element)
          .closest('.form-group')
          .removeClass('has-success')
          .addClass('has-error');
      },
      unhighlight: function (element) {
        $(element)
          .closest('.form-group')
          .removeClass('has-error')
          .addClass('has-success');
      },
      submitHandler: form => {
        this.stripe_cardadd();
      }
    });
  }

  telephone_input_validate() {
    $('#sendernumber,#receivernumber').intlTelInput({
      autoHideDialCode: true,
      // geoIpLookup: function (callback) {
      //   $.get('https://ipapi.co/json/').always(function (res) {
      //     if (res.status >= 400 || res.error) {
      //       $.get('https://ipinfo.io', function () { }, 'jsonp').always(function (
      //         resp
      //       ) {
      //         console.log(resp);
      //         const countryCode = resp && resp.country ? resp.country : '';
      //         callback(countryCode);
      //       });
      //     } else {
      //       const countryCode = res && res.country ? res.country : '';
      //       callback(countryCode);
      //     }
      //   });
      // },
      initialCountry: 'ZA',
      nationalMode: false,
      separateDialCode: true,
      utilsScript:
        'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.4/js/utils.js'
    });
    setTimeout(() => {
      this.initialCountryCode = $('#sendernumber').intlTelInput(
        'getSelectedCountryData'
      ).dialCode;
      this.initialCountryFlag = $('#sendernumber').intlTelInput(
        'getSelectedCountryData'
      ).iso2;
    }, 1000);

    const telInput = $('#phone'),
      errorMsg = $('#error-msg'),
      validMsg = $('#valid-msg');
    const reset = function () {
      telInput.removeClass('error');
      errorMsg.addClass('hide');
      validMsg.addClass('hide');
    };
    telInput.blur(function () {
      reset();
      if ($.trim(telInput.val())) {
        if (telInput.intlTelInput('isValidNumber')) {
          validMsg.removeClass('hide');
        } else {
          telInput.addClass('error');
          errorMsg.removeClass('hide');
        }
      }
    });
    $.validator.addMethod(
      'uniqueUserName',
      function (value, element) {
        if (telInput.intlTelInput('isValidNumber')) {
          return true;
        } else {
          return false;
        }
      },
      'Please enter valid number'
    );
  }

  jquery_func_trigger() {
    $('.vehicletypes_but').on('click', 'li', function () {
      $('#popup_dropdown:first-child').text($(this).text());
      $('#popup_dropdown:first-child').val($(this).text());
      this.vechicle_type = $(this).attr('id');
      localStorage.setItem('vechileType', this.vechicle_type);
    });
    $('#wght_value,#card-ccv').keypress(function (event) {
      const $this = $(this);
      if (
        (event.which != 46 || $this.val().indexOf('.') != -1) &&
        (event.which < 48 || event.which > 57) &&
        event.which != 0 &&
        event.which != 8
      ) {
        event.preventDefault();
        const text = $(this).val();
        if (event.which == 46 && text.indexOf('.') == -1) {
          setTimeout(function () {
            if ($this.val().substring($this.val().indexOf('.')).length > 3) {
              $this.val($this.val().substring(0, $this.val().indexOf('.') + 3));
            }
          }, 1);
        }
        if (
          text.indexOf('.') != -1 &&
          text.substring(text.indexOf('.')).length > 2 &&
          event.which != 0 &&
          event.which != 8 &&
          $(this)[0].selectionStart >= text.length - 2
        ) {
          event.preventDefault();
        }
      }
    });
    $('.input-cart-number').on('keyup change', $event => {
      $('.card_error_msg').remove();

      let card_number = '';
      $('.input-cart-number').each(function () {
        card_number += $(this).val() + ' ';
        if ($(this).val().length == 4) {
          let attrb = parseInt($(this).attr('data-attribute'));
          attrb++;
          $('#card-number-' + attrb).focus();
        }
      });
      this.card_number_all = card_number.replace(/ /g, '');
      this.GetCardType(this.card_number_all);
      $('.credit-card-box .number').html(card_number);
    });
    $('#card-holder').on('keyup change', function ($event) {
      $('.credit-card-box .card-holder div').html($event.target.value);
    });
    $('#card-expiration-month, #card-expiration-year').change($event => {
      $('.month_error_msg').remove();
      let m, y;
      m = $('#card-expiration-month option:selected').val();
      y = $('#card-expiration-year').val();
      if (y != null) {
        y = $('#card-expiration-year').val();
      } else {
        y = '';
      }
      $('.card-expiration-date div').html(m + '/' + y);
      const that = this;
      that.month_year(m, y);
    });

    $('#card-ccv')
      .on('focus', $event => {
        $('.credit-card-box').addClass('hover');
      })
      .on('blur', function () {
        $('.credit-card-box').removeClass('hover');
      })
      .on('keyup change', $event => {
        $('.ccv div').html($event.target.value);
        this.card_cvc = $event.target.value;
      });
    $('#add_popup_but').click(function () {
      // $("#contact-form").valid();
    });
    jQuery('#book_now_pop_button').trigger('click');
    $(function () {
      $(document.body).on('show.bs.modal', function () {
        $(document.body).addClass('modal-open');
      });
      $(document.body).on('hide.bs.modal', function () {
        $(document.body).removeClass('modal-open');
      });
    });
    jQuery('#book_now_pop_button').click(function () {
      $('this').addClass('active');
    });
    jQuery('#right_front_div').hide();
    jQuery('.front_div_close').click(function () {
      jQuery('#right_back_div').toggle();
      jQuery('#right_front_div').hide();
    });
    jQuery('#right_taks_but').click(function () {
      jQuery('.tasks_list_right').toggle();
    });
    jQuery('.connections_div').click(function () {
      jQuery('#right_back_div').toggle();
      jQuery('#right_front_div').show();
    });
    jQuery('#job_details_button').trigger('click');
    jQuery('#bulk_import_but').click(function () {
      jQuery('#bulk_import_but')
        .find('span')
        .toggleClass('active');
    });
    $('#assigned_but').click(() => {
      $('#left_full_body').hide();
      this.passDetailsContent = [];
    });
    $('#un_assigned_but').click(() => {
      $('#left_full_body').show();
      this.passDetailsContent = [];
    });
    $('#completed_but').click(() => {
      $('#left_full_body').hide();
      this.passDetailsContent = [];
    });
    $('#origin-input2').change(() => {
      clearInterval(this.vehicles_interval);
      this.pickup_loc_bool = false;
    });
    $('#origin-input3').change(() => {
      clearInterval(this.vehicles_interval);
      this.drop_loc_bool = false;
    });
    jQuery('.width_3').click(function () {
      jQuery('.width_3').removeClass('active');
      jQuery(this).addClass('active');
    });
    jQuery('.width_3_rt').click(function () {
      jQuery('.width_3_rt').removeClass('active');
      jQuery(this).addClass('active');
    });
    jQuery(document).keydown(e => {
      // ESCAPE key pressed
      if (e.keyCode == 27) {
        $('.modal').modal('hide');
      }
    });
    jQuery('.mute_onn').click(function () {
      // $(this).toggleClass("glyphicon-volume-up glyphicon-volume-off");
      // $(this).toggleClass("glyphicon-volume-off");
    });
    jQuery('.left_marker').click(function () {
      const k = jQuery('.left-window').width();
      const y = jQuery(window).width();
      const result = y - k;
      if (jQuery('.left-window').hasClass('open')) {
        jQuery('.left-window').animate({ left: -k });
        jQuery('.left-window').removeClass('open');
        jQuery('.icn_left').addClass('rotate_pointer');
        jQuery('#map>div').animate({ marginLeft: '0%' });
      } else {
        jQuery('.left-window').animate({ left: '0' });
        jQuery('.left-window').addClass('open');
        jQuery('.icn_left').removeClass('rotate_pointer');
        jQuery('#map>div').animate({ marginLeft: k });
      }
    });
    jQuery('.right_marker').click(function () {
      const k = jQuery('.left-window').width();
      const y = $(window).width();
      const result = y - k;
      if (jQuery('.right-window').hasClass('open')) {
        jQuery('.right-window').animate({ right: -k });
        jQuery('.right-window').removeClass('open');
        jQuery('.icn_right').addClass('rotate_pointer');
        jQuery('#map>div').animate({ width: '100%' });
      } else {
        jQuery('.right-window').animate({ right: '0' });
        jQuery('.right-window').addClass('open');
        jQuery('.icn_right').removeClass('rotate_pointer');
        jQuery('#map>div').animate({ width: result });
      }
    });
    $('#noservice_ok_but,#noservice_ok_but2').click(() => {
      this.show_error_bool = false;
      $('#error_popup_parent,#credit_popup_parent').hide();
    });
    $('#myModal').on('hidden.bs.modal', () => {
      // same as initial loading country flag
      // const classes = $('.receiver_number_parent2 .iti-flag').attr('class').split(' ');
      // const classes2 = $('.receiver_number_parent .iti-flag').attr('class').split(' ');
      // $(".receiver_number_parent2 .selected-dial-code, .receiver_number_parent .selected-dial-code").text("+" + this.initialCountryCode);
      // $(".receiver_number_parent2 .iti-flag").removeClass(classes[1]);
      // $(".receiver_number_parent .iti-flag").removeClass(classes2[1]);
      // $(".receiver_number_parent2 .iti-flag, .receiver_number_parent .iti-flag").addClass(this.initialCountryFlag);
      // // same as initial loading country flag
      // clearInterval(this.credit_line_interval);
      $('#origin-input2').val('');
      $('.form-group.has-feedback').removeClass('has-success');
      $('.remove_details input,textarea').val('');
      $('.img-ul-clear').trigger('click');

      $('#est_journey').text('...');
      this.zone_one_title = ' ';
      this.zone_two_title = ' ';
      this.vehicletypeid = '';
      this.product_wid = '';
      this.product_lgt = '';
      this.product_ht = '';
      this.handlers = 0;
      this.fareEstimateDetails = '';
      // this.currency = '...';
      this.product_qty = '';
      $('#est_journey').text('');
      $('#choose_file_span').text('');
      this.approx = '.....';
      this.approx_dist_txt = '';
      this.duration = '';
      this.card_number = '';
      this.droplat = '';
      this.droplong = '';
      this.rec_name = '';
      this.rec_number = '';
      this.paidBy = 1;
      this.payment_type = 2;
      this.distance_text = '....';
      this.duration_txt = '....';
      this.show_ratecard = false;
      this.isCardEnable = false;
      this.isCashEnable = false;
      this.isWalletEnable = false;
      clearInterval(this.vehicles_interval);
      $('#sender_input').attr('checked', false);
      $('#loader_place2').hide();
      $('.form-group').removeClass('has-error');
      $('.form-group').removeClass('has-success');
      $('label.error').remove();
      $('.multiple_img').hide();
      $('.ref_img1').show();
      $('.delete_photo_icn').hide();
      $('#upload1,#upload2,#upload3,#upload4,#upload5').attr(
        'src',
        './assets/img/image_upload.png'
      );
      this.file = [];
      $('select[name=goodstype]').val(
        $('select[name=goodstype] option:first').val()
      );
      $('select[name=handlers]').val(
        $('select[name=handlers] option:first').val()
      );
      $('select[name=vehicletype]').val(
        $('select[name=vehicletype] option:first').val()
      );
      $('select[name=handlers]').val(
        $('select[name=handlers] option:first').val()
      );
      $('select[name=payment_method]').val(
        $('select[name=payment_method] option:first').val()
      );
      $('#f-option2').trigger('click');
      $('#s-option4').trigger('click');
      $('#s-option1').trigger('click');
      $('#cbWalletBal').prop('checked', false);
      this.walletPay = 0;
      this.showAllPayments = false;
      // card triggers
    });
    $('#addnew_but').click(() => {
      this.addnew_job();
    });
  }
  gMapKey;
  firstLoad = true;
  faceBookLink: any;
  twitterLink: any;
  appconfig() {
    this._dispatcherService.appconfig({}).subscribe((res: any) => {
      console.log('appconfig--------------->', res);
      this._cookie.setConfig(res.data);
      this.weightMetrics = res.data.weightMetrics;
      this.get_dates(res.data.shipmentLaterBookingAppBuffer);
      this.walletEnable = res.data.wallet.isEnabled;
      this.isBiddingEnabled = res.data.appSettings.bidding;
      this.isBookNowEnabled = res.data.appSettings.bookNow;
      this.isBookLaterEnabled = res.data.appSettings.bookLater;
      this.isReceiverConfirmationEnabled =
        res.data.appSettings.recieverConfirmation;
      this.isSecurityOtpIsEnabled = res.data.appSettings.securityOtp;
      this.faceBookLink = res.data.facebookLink;
      this.twitterLink = res.data.twitterLink;
      this.metric_ton = 'Kg';
      $('#weight_units>option:eq(0)').prop('selected', true);
      // if ($('#back_button').css('display') === 'none') {
      //   $('.booking_buutns').show();
      //   this.isBiddingEnabled = res.data.appSettings.bidding;
      //   this.isBookNowEnabled = res.data.appSettings.bookNow;
      //   this.isBookLaterEnabled = res.data.appSettings.bookLater;
      // }
      // else {
      //   $('.booking_buutns').hide();
      //   this.isBiddingEnabled = false;
      //   this.isBookNowEnabled = false;
      //   this.isBookLaterEnabled = false;
      // }
    });
  }

  wallet() {
    this._dispatcherService.wallet({}).subscribe((res: any) => {
      console.log('wallet', res.data);
      this._cookie.setWalletDetails(res.data);
      this.currency = res.data.currencySymbol;
      this.showing_balance = this._cookie.getWalletDetails('walletBalance');
      this.walletEnable = res.data.isEnabled;
    });
  }
  frameLink: any;
  open_card_div() {
    // this.getallcards();
    // if (this.allcards.length > 0) {
    //   this.hideNewcard();
    // } payfast payment gateway
    let amount = this.finalHandlersPrice
      ? this.finalHandlersPrice.toString()
      : this.approx.toString();
    let userId = this._cookie.getItem('sid');
    let phoneNumber = this._cookie.getItem('phoneNumber').replace(' ', '');
    //http://52.47.115.187/PayFast/payfast.php?"+"userId=" +
    //userId value + "&userType=1&amount=" + amount + "&requestedFor=0&paymentTypeMethod=cc" + "&bookingId=" + mobile number 
    let cardLink = `http://52.47.115.187/PayFast/payfast.php?userId=${userId}&userType=1&amount=${amount}&requestedFor=1&paymentTypeMethod=cc&bookingId=${phoneNumber}`;
    console.log('cardLink', cardLink)
    // window.open(cardLink, '_blank');
    this.frameLink = this.sanitizer.bypassSecurityTrustResourceUrl(cardLink);
    let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=300,left=400,top=200`;

    this.card_window = open(cardLink, 'test', params);
    // setTimeout(() => {
    //   $('.booking_loader_parent').hide();
    //   // $('.select_cards').removeClass('has-error');
    // }, 1000);
    // $('#credit_card_popup').modal('show');
  }

  getallcards() {
    this.allcards = [];
    this._dispatcherService.getcards({}).subscribe(
      (res: any) => {
        $('.loader_cardadd_parent').hide();

        if (res.data.cards.length > 0) {
          for (let inst = 0; inst < res.data.cards.length; inst++) {
            this.allcards.push(res.data.cards[inst]);
            if (res.data.cards[inst].isDefault == true) {
              this.defaultcard = res.data.cards[inst];
              $('#' + this.allcards[inst].id).attr('checked', true);
            }
          }
        } else {
          this.allcards = [];
          this.hideSelectcard();
          this.defaultcard = '';
        }
        console.log('allcards', res);
        // console.log('defaultcard', this.allcards);
      },
      err => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 520:
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 400:
            this.errMsg = err.error;
            toastr['error'](this.errMsg.message);
            break;
          case 401:
            this.errMsg = err.error;
            this._router.navigate(['login']);
            toastr['warning'](
              this.errMsg.message + '<br> You have been Logged out!'
            );
            break;
          case 420:
            this.errmessage = err.error;
            this.errmessage = this.errmessage.message;
            break;
        }
      }
    );
  }

  select_card(item) {
    console.log('selected Card', item);
    this.defaultcard = item;
    $('.check_id' + item.id).prop('checked', true);
    $('.cash_cards').removeClass('active');
    $('.card_id' + item.id).addClass('active');
  }

  changeDefault(item) {
    console.log('selected Card', item);
    this.defaultcard = item;
    $('.check_id' + item.id).prop('checked', true);
    $('.card_id' + item.id).addClass('active');
  }

  dcard(card) {
    console.log(card.id);
    this._dispatcherService
      .deletecard({
        cardId: card.id
      })
      .subscribe((res: any) => {
        console.log('delete cards---------->', res);
        swal('success!', this.languageTexts.swalTexts['cardDeleteSuccess'], 'success');
        this.getallcards();
      });
  }

  hideSelectcard() {
    $('.card_buttons').removeClass('active');
    $('.add_card_button').addClass('active');
    $('#added_cards_div').hide(500);
    $('#new_cards_div').show(500);
    $('#card-number').focus();
    this.card_number_all = '';
  }
  hideNewcard() {
    $('.card_buttons').removeClass('active');
    $('.select_card_button').addClass('active');
    $('#new_cards_div').hide(500);
    $('#added_cards_div').show(500);
  }
  GetCardType(number) {
    this.visa = false;
    this.amex = false;
    this.discover = false;
    this.jcb = false;
    this.diners = false;
    this.master = false;
    // visa
    let re = new RegExp('^4');
    if (number.match(re) != null) {
      this.visa = true;
      return 'Visa';
    }
    // Mastercard
    re = new RegExp('^5[1-5]');
    if (number.match(re) != null) {
      this.master = true;
      return 'Mastercard';
    }
    // AMEX
    re = new RegExp('^3[47]');
    if (number.match(re) != null) {
      this.amex = true;
      return 'AMEX';
    }
    // Discover
    re = new RegExp(
      '^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)'
    );
    if (number.match(re) != null) {
      this.discover = true;
      return 'Discover';
    }
    // Diners
    re = new RegExp('^36');
    if (number.match(re) != null) {
      this.diners = true;
      return 'Diners';
    }
    // Diners - Carte Blanche
    re = new RegExp('^30[0-5]');
    if (number.match(re) != null) {
      this.diners = true;
      return 'Diners - Carte Blanche';
    }
    // JCB
    re = new RegExp('^35(2[89]|[3-8][0-9])');
    if (number.match(re) != null) {
      this.jcb = true;
      return 'JCB';
    }
    // Visa Electron
    re = new RegExp('^(4026|417500|4508|4844|491(3|7))');
    if (number.match(re) != null) {
      this.visa = true;
      return 'Visa Electron';
    }
    return 'NOT';
  }
  stripe_cardadd() {
    $('.card_error_msg').remove();
    $('.month_error_msg').remove();
    const card =
      $('#card-number').val() +
      $('#card-number-1').val() +
      $('#card-number-2').val() +
      $('#card-number-3').val();
    const mm = $('#card-expiration-month option:selected').val();
    const yy = $('#card-expiration-year option:selected').val();
    if (card.length < 14 || mm == '00' || yy == '00') {
      if (card.length < 14)
        $('.card_number_valid').append(
          '<span class="card_error_msg">' +
          this.disphome.validCardNum +
          '</span>'
        );
      else
        $('.fieldset-expiration').append(
          '<span class="month_error_msg">' +
          this.disphome.validExpiry +
          '</span>'
        );
    } else {
      $('.card_error_msg').remove();
      $('.month_error_msg').remove();
      $('.loader_cardadd_parent').show();
      const stripekey = this._cookie.getConfig('stripe');
      Stripe.setPublishableKey(stripekey);
      Stripe.createToken(
        {
          number: parseInt(this.card_number_all),
          cvc: parseInt(this.card_cvc),
          exp_month: this.card_month.toString(),
          exp_year: this.card_year.toString()
        },
        (status, response) => {
          if (response['id'] != undefined) {
            this.addcards(response['id']);
            this.getallcards();
          } else {
            $('.error_card_msg').css('color', 'red');
            $('.error_card_msg').text(response.error.message);
            setTimeout(() => {
              $('.error_card_msg').text('');
            }, 2000);
            $('.loader_cardadd_parent').hide();
          }
        }
      );
    }

  }

  month_year(m, y) {
    this.card_month = m;
    this.card_year = y;
  }
  usecard() {
    const cardid = $('input[name=card_select]:checked').val();
    if (cardid == undefined) {
      alert('please select a card');
    } else {
      this.card_number = $('input[name=card_select]:checked').val();
      $('.card_block').removeClass('has-error');
      $('.card_block').addClass('has-success');
      $('#credit_card_popup').modal('hide');
    }
  }

  resetForm() {
    this.cardsTransctionData = '';
    this.ScatchelsData = [];
    this.removeMarkers();
    this.favoriteDrivers = [];
    this.favoriteDriverId = '';
    this.handlersArr = [];
    this.temp_finalAmount = '';
    this.goods_type_list = [];
    this.vehicle_types = [];
    this.choosePrice = '';
    this.codAmount = '';
    if (this.initialCountryFlag) {
      $('#receivernumber, #sendernumber').intlTelInput(
        'setCountry',
        this.initialCountryFlag
      );
    }
    $('#switch').removeClass('hover');
    this.enableBidding = false;
    $('#form1')[0].reset();
    this.showWeight = true;
    $('#f-option1').prop('checked', true);
    $('#f-option2').prop('checked', false);
    $('.codAmount').prop('checked', false);
    this.loadtype = 'LTL';
    this.IsPriceFixed = false;
    this.currentVehicleCapacity = '';
    $('#approx_distance').text(`...`);
    this.enableBidding = false;
    this.finalHandlersPrice = 0;
    this.isPaidByReceiverEnable = true;
    this.perHandlersPrice = undefined;
    this.metric_ton = 'Kg';
    this.show_cards = false;
    $('#sendername, #sendernumber, #receivernumber, #sendernumber').attr(
      'disabled',
      false
    );
    // old code

    $('#origin-input2').val('');
    $('.form-group.has-feedback').removeClass('has-success');
    $('.remove_details input,textarea').val('');
    $('.img-ul-clear').trigger('click');

    $('#est_journey').text('...');
    this.zone_one_title = ' ';
    this.zone_two_title = ' ';
    this.vehicletypeid = '';
    this.product_wid = '';
    this.product_lgt = '';
    this.product_ht = '';
    this.handlers = 0;
    this.fareEstimateDetails = '';
    // this.currency = '...';
    this.product_qty = '';
    $('#est_journey').text('');
    $('#choose_file_span').text('');
    this.approx = '.....';
    this.approx_dist_txt = '';
    this.duration = '';
    this.card_number = '';
    this.droplat = '';
    this.droplong = '';
    this.rec_name = '';
    this.rec_number = '';
    this.paidBy = 1;
    this.payment_type = 2;
    this.distance_text = '....';
    this.duration_txt = '....';
    this.show_ratecard = false;
    this.isCardEnable = false;
    this.isCashEnable = false;
    this.isWalletEnable = false;
    this.showAllPayments = false;
  }

  ngOnInit() {
    // save user data on local
    this.addcard = this.languageService.add_card;
    setTimeout(() => {
      this._dispatcherService.getProfile().subscribe(
        (data: any) => {
          sessionStorage.setItem(
            'userName',
            `${data.data.firstName} ${data.data.lastName}`
          );
          sessionStorage.setItem('phone', data.data.phone);
        },
        error => {
          console.log(error);
        }
      );
      // console.log(this.subscriptions);
    }, 2000);
    this.initMap();
    // model close function to clear form details
    $('#myModal').on('hidden.bs.modal', () => {
      this.goods_type_list = [];
      this.vehicle_types = [];
      if (this.initialCountryFlag) {
        $('#receivernumber, #sendernumber').intlTelInput(
          'setCountry',
          this.initialCountryFlag
        );
      }
      $('#switch').removeClass('hover');
      this.enableBidding = false;
      $('#form1')[0].reset();
      this.showWeight = true;
      $('#f-option1').prop('checked', true);
      $('#f-option2').prop('checked', false);
      this.loadtype = 'LTL';
      this.IsPriceFixed = false;
      this.currentVehicleCapacity = '';
      $('#approx_distance').text(`...`);
      this.enableBidding = false;
      this.finalHandlersPrice = 0;
      this.isPaidByReceiverEnable = true;
      this.perHandlersPrice = undefined;
      this.metric_ton = 'Kg';
      $('#sendername, #sendernumber, #receivernumber, #sendernumber').attr(
        'disabled',
        false
      );
      // old code

      $('#origin-input2').val('');
      $('.form-group.has-feedback').removeClass('has-success');
      $('.remove_details input,textarea').val('');
      $('.img-ul-clear').trigger('click');

      $('#est_journey').text('...');
      this.zone_one_title = ' ';
      this.zone_two_title = ' ';
      this.vehicletypeid = '';
      this.product_wid = '';
      this.product_lgt = '';
      this.product_ht = '';
      this.handlers = 0;
      this.fareEstimateDetails = '';
      // this.currency = '...';
      this.product_qty = '';
      $('#est_journey').text('');
      $('#choose_file_span').text('');
      this.approx = '.....';
      this.approx_dist_txt = '';
      this.duration = '';
      this.card_number = '';
      this.droplat = '';
      this.droplong = '';
      this.rec_name = '';
      this.rec_number = '';
      this.paidBy = 1;
      this.payment_type = 2;
      this.distance_text = '....';
      this.duration_txt = '....';
      this.show_ratecard = false;
      this.isCardEnable = false;
      this.isCashEnable = false;
      this.isWalletEnable = false;
    });
    if (!sessionStorage.getItem('authtoken')) {
      this._router.navigate(['login']);
    } else {
      console.log("added")
      this.appconfig();
      this.wallet();
      // this.addcard = this.languageService.add_card;
      console.log("card", this.addcard)
      this.disphome = this.languageService.dispatcherhome;
      this.accountType = parseInt(this._cookie.getSettings('accountType'));
      this.card_wallet_validate();
      toastr.options = {
        closeButton: true,
        debug: false,
        newestOnTop: true,
        progressBar: true,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
        showDuration: '300',
        hideDuration: '1000',
        timeOut: '3000',
        extendedTimeOut: '1000',
        showEasing: 'swing',
        hideEasing: 'linear',
        showMethod: 'fadeIn',
        hideMethod: 'fadeOut'
      };
      // this.getVechicles();
      this.currentlat();
      // this.get_dates();
      this.telephone_input_validate();
      this.jquery_func_trigger();
      // this.profile_me();
      // $("#review_popup").modal('show');
      // this.pending_reviews();
      // this.getvehicles();
      let autocomplete;

      setTimeout(() => {
        this.directionsDisplay = new google.maps.DirectionsRenderer({
          // google path no default markers
          suppressMarkers: true
        });
        // end of custom file input
        autocomplete = new google.maps.places.Autocomplete(
          document.getElementById('pac-input2'),
          { types: ['geocode'] }
        );
      }, 1000);

      this.current_time = new Date();
      this.current_time_var = moment().format('YYYY-MM-DD HH:mm:ss');

      // When the user selects an address from the dropdown, populate the address
      // fields in the form.

      $('.fullscreen_icn').on('click', event => {
        screenfull.toggle();
        $('.fullscreen_icn').toggleClass('glyphicon-fullscreen');
        $('.fullscreen_icn').toggleClass('glyphicon-resize-small');
      });

      $('.dropdown-toggle').click(function (e) {
        // console.log('clicked');
        if ($(e.target).is('#notification_body,#notification_body *')) {
          return;
        } else {
          $('#notification_body').hide();
        }
      });
      $(document).click(function (e) {
        // console.log('clicked');
        if ($(e.target).is('#notification_body,#notification_body *')) {
          return;
        } else {
          $('#notification_body').hide();
        }
      });

      this.validate_form = $('#form1').validate({
        rules: {
          username: {
            required: true
          },
          phonenumber: {
            required: true
          },
          email: {
            email: true,
            required: true
          },
          time: {
            required: true
          },
          weight: {
            minlength: 1,
            required: true
          },
          date: {
            required: this.bookNow ? false : true
          },
          receivername: {
            minlength: 3,
            required: true
          },
          receivernumber: {
            // maxlength: 20,
            uniquePhonenumber: true,
            required: true
          },
          receiveremail: {
            email: true,
            required: true
          },
          password: {
            minlength: 5,
            required: true
          },
          payment: {
            required: true
          },
          pickuplocation: {
            findlocation: true,
            required: true
          },
          receiveraddress: {
            finddroplocation: true,
            required: true
          },
          goodstype: {
            required: true
          },
          vehicletype: {
            required: true
          },
          later_date: {
            // minlength: 3,
            required: true
          },
          pickup_date: {
            required: true
          },
          sendername: {
            minlength: 3,
            required: true
          },
          sendernumber: {
            uniqueUserName: true,
            required: true
          },
          approx_amount: {
            required: true
          },
          handlers: {
            required: true
          }
        },
        highlight: function (element) {
          $(element)
            .closest('.form-group')
            .removeClass('has-success')
            .addClass('has-error');
        },
        unhighlight: function (element) {
          $(element)
            .closest('.form-group')
            .removeClass('has-error')
            .addClass('has-success');
        },
        submitHandler: form => {
          // console.log('form===>', form);
          if (!this.bookNow) {
            if (this.validate_form.element('.flatpickr')) {
              if (this.validate_form.element('.flatpickr2')) {
                this.addinfo();
                // this.livebooking();
                // console.log('submit handler if');
              }
            }
          } else {
            // this.payment_type == 1 ? this.open_card_div() : '';
            // console.log('submit handler else');
            this.addinfo();
            // this.livebooking();
          }
        }
      });
      const telInput = $('#sendernumber'),
        telInput2 = $('#receivernumber'),
        errorMsg = $('#error-msg'),
        validMsg = $('#valid-msg');
      const reset = function () {
        telInput.removeClass('error');
        errorMsg.addClass('hide');
        validMsg.addClass('hide');
      };
      $.validator.addMethod(
        'findlocation',
        (value1: any, element) => {
          if (this.pickup_loc_bool && this.pickup_bool) {
            return true;
          } else {
            return false;
          }
        },
        'Please enter valid location'
      );
      $.validator.addMethod(
        'finddroplocation',
        (value2, element) => {
          if (this.drop_loc_bool && this.drop_bool) {
            return true;
          } else {
            return false;
          }
        },
        'Please enter valid location'
      );
      $.validator.addMethod(
        'uniqueUserName',
        function (value, element) {
          if (telInput.intlTelInput('isValidNumber')) {
            return true;
          } else {
            return false;
          }
        },
        'Please enter valid number'
      );
      $.validator.addMethod(
        'uniquePhonenumber',
        function (value, element) {
          // console.log('value--->', telInput2, value, telInput2.intlTelInput('isValidNumber'));
          if (telInput2.intlTelInput('isValidNumber')) {
            return true;
          } else {
            return false;
          }
        },
        'Please enter valid number'
      );
    }
    // $("#sendernumber").intlTelInput
    $('#sendernumber').on('countrychange', e => {
      // do something with countryData
      if ($('#sender_input').is(':checked')) {
        const countryData = $('#sendernumber').intlTelInput(
          'getSelectedCountryData'
        ).dialCode;
        // const countryData_id = $("#sendernumber").intlTelInput("getSelectedCountryData").iso2;
        // const classes = $('.receiver_number_parent2 .iti-flag').attr('class').split(' ');
        // console.log(classes);
        // $(".receiver_number_parent2 .selected-dial-code").text("+" + countryData);
        // $(".receiver_number_parent2 .iti-flag").removeClass(classes[1]);
        // $(".receiver_number_parent2 .iti-flag").addClass(countryData_id);
        const senderNumber = $('#sendernumber').val();
        // console.log('sender name and number', senderNumber, countryData);
        const number = `+${countryData}${senderNumber}`;
        $('#receivernumber').intlTelInput('setNumber', number);
        this.rec_name = this.senderName;
        setTimeout(() => {
          this.validate_form.element('#receivername');
          this.validate_form.element('#receivernumber');
        }, 100);
      }
    });
  }

  errMsg: any;
  errmessage: any;
  addcards(cardid) {
    $('.card_error_msg').remove();
    $('.month_error_msg').remove();
    $('.loader_cardadd_parent').show();
    this._dispatcherService
      .addcards({
        email: this._cookie.getItem('email'),
        cardToken: cardid
      })
      .subscribe(
        (res: any) => {
          $('.select_card_button').trigger('click');
          // this.cardsDetails = res.data;
          // this.open_card();
          $('#card-expiration-month option:selected').val();
          $('#card-expiration-month').val(
            $('#card-expiration-month option:first').val()
          );
          $('#card-expiration-year').val(
            $('#card-expiration-year option:first').val()
          );
          $(
            '.ccv div,.card-expiration-date div,.credit-card-box .card-holder div,.credit-card-box .number'
          ).empty();
          $('#credit_card_popup input').val('');
          $('.loader_cardadd_parent').hide();
          $('.select_card_button').trigger('click');
          $('#new_cards_div').hide();
          this.card_number = '';
        },
        err => {
          console.log('errMsg', err.status);
          if (err.status > 401 && err.status < 500) {
            err.status = 420; // merging all the status codes to one status code 420
          }
          if (err.status > 499) {
            err.status = 520; // merging all the status codes to one status code 420
          }
          switch (err.status) {
            case 0:
              toastr['error']('Server Not Responding!');
            case 520:
              $('.loader_cardadd_parent').hide();
              this.errMsg = err.error;
              toastr['error'](this.errMsg.message);
              break;
            case 400:
              $('.loader_cardadd_parent').hide();
              this.errMsg = err.error;
              toastr['error'](this.errMsg.message);
              break;
            case 401:
              this._cookie.removeItem();
              this._router.navigate(['login']);
              break;
            case 420:
              $('.loader_cardadd_parent').hide();
              this.errmessage = err.error;
              this.errmessage = this.errmessage.message;
              break;
          }
        }
      );
  }

  /**
   *
   * @description Get the languages the Application Supports from the Server
   * @memberof DispatcherComponent
   */
  getLanguages() {
    this._dispatcherService.getLanguages().subscribe(
      (res: any) => {
        console.log(res);
        this.allLanguages = res.data;
        this.translate.setDefaultLang('en');
        this._cookie.setItems('lang', 'en');
        if (this._cookie.getItem('lang')) {
          this.defaultLanguage = this._cookie.getItem('lang');
          const index = this.allLanguages.find(
            language => language.code === this.defaultLanguage
          );
          if (index) {
            this.translate.use(this.defaultLanguage);
          } else {
            this.translate.use('en');
          }
        } else {
          this._cookie.setItems('lang', 'en');
          this.translate.use('en');
        }

        console.log(this.defaultLanguage, this._cookie.getItem('lang'));
      },
      err => {
        console.log(err);
      }
    );
  }

  /**
  *
  *
  * @param string lang
  * @memberof DispatcherComponent
  * @description switch language
  */
  changeLanguage(lang) {
    this.translate.use(lang);
    this._cookie.setNewCookie('lang', lang, 10);
    // let lang = this._cookie.getItem('lang');
    // console.log('lang', lang);
    this.translate.getTranslation(lang).subscribe((res: string) => {
      console.log("translate", res);
      this.languageTexts = res;
      //=> 'hello world'
    });
  }
  backToDispatcherHome() {
    this.appconfig();
    if ($('#back_button').css('display') === 'none') {
      $('.booking_buutns').show();
    }
    else {
      $('.booking_buutns').hide();
    }
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  getcodAmount(event, val) {
    if (val == 0) {
      event && event.target ? this.codAmount = event.target.value : '';
    }

  }
}
